import { html } from "common-tags"

export function parseSublimeText(
  description: string,
  tabTrigger: string,
  snippet: string
) {
  const regexpMagic = /(\$)([a-z(]+)([^$])/gi
  const escapedSnippet = snippet.replace(regexpMagic, "\\$1$2$3")
  return html`
    <snippet>
      <content><![CDATA[ ${escapedSnippet} ]]></content>
      <tabTrigger>${tabTrigger}</tabTrigger>
      <description>${description}</description>
    </snippet>
  `
}
